/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react'
import moment from 'moment'
import { Col, Dropdown, Form, InputGroup, Modal, Row } from 'react-bootstrap'

import { OCCURENCES } from '@constants/Settings'
import { activeProvider } from '@assets/mockdata'
import Button from '@components/common/Button/Button.component'

type SchedulerModalProps = {
  isOpen: boolean
  toggleModal: () => void
  currentDate: string
}

type Days =
  | 'sunday'
  | 'monday'
  | 'tuesday'
  | 'wednesday'
  | 'thursday'
  | 'friday'
  | 'saturday'

function SchedulerModal({
  isOpen,
  toggleModal,
  currentDate,
}: SchedulerModalProps): React.ReactElement {
  const [selectedOccurences, setSelectedOccurences] = useState('')
  const [providers, setProviders] =
    useState<{ [key: string]: any }[]>(activeProvider)

  const handleCheckboxChange = (
    providerId: string,
    isChecked: boolean,
  ): void => {
    setProviders((prevItems) =>
      prevItems.map((item) => {
        if (item.providerId === providerId) {
          return {
            ...item,
            repeats: { occurences: selectedOccurences, value: isChecked },
          }
        }
        return item
      }),
    )
  }

  const day: Days = moment(currentDate, 'YYYY-MM-DD')
    .format('dddd')
    .toLowerCase() as Days
  return (
    <Modal
      show={isOpen}
      onHide={toggleModal}
      backdrop="static"
      keyboard={false}
      size="lg"
    >
      <Modal.Header className="bg-custom3 text-dark" closeButton>
        {moment(currentDate, 'YYYY-MM-DD').format('dddd MMMM Do YYYY')}
      </Modal.Header>
      <Modal.Body>
        <Row className="mt-3">
          <Col md={12}>
            <span className="fs-5">
              This will change scheduled hours to zero.
            </span>
          </Col>
          <Col md={7} className="mt-2">
            <Form.Group className="mb-1">
              <Form.Label className="label-top">Repeats</Form.Label>
              <InputGroup>
                <Form.Select
                  value={selectedOccurences}
                  onChange={(e) => setSelectedOccurences(e.target.value)}
                  className="form-control"
                >
                  <option
                    key={'this-occurences-only'}
                    value={'this-occurences-only'}
                  >
                    {'This Occurrence Only'}
                  </option>
                  {OCCURENCES[day]?.map(({ value, label }) => (
                    <option key={value} value={value}>
                      {label}
                    </option>
                  ))}
                </Form.Select>
              </InputGroup>
            </Form.Group>
          </Col>
          <Col md={5} className="mt-2">
            <Dropdown className="" autoClose={false}>
              <Dropdown.Toggle variant="light" id="" style={{ width: '100%' }}>
                Applies To:
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {providers.map((provider) => (
                  <>
                    <Dropdown.Item key={provider?.repeats?.value}>
                      <Form.Check
                        type="checkbox"
                        label={`${provider.firstname} ${provider.lastname}`}
                        value={provider.providerId}
                        checked={provider?.repeats?.value ?? false}
                        onChange={(e) =>
                          handleCheckboxChange(e.target.value, e.target.checked)
                        }
                      />
                    </Dropdown.Item>
                  </>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button size="md" className="button-primary">
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default SchedulerModal
